import(/* webpackMode: "eager" */ "/codebuild/output/src2126065393/src/stage-webapp/src/app/global-error.tsx");
